import { Typography } from '@mui/material';
import type { Order } from '../../api/order';
import { formatOrderListDueDate, getOrderTimingLine } from '../utils/order';
import OrderListCell from './OrderListCell';

interface OrderDueDateCellProps {
  order: Order;
}

const OrderDueDateCell = ({ order }: OrderDueDateCellProps) => {
  const timing = getOrderTimingLine(order);
  return (
    <OrderListCell>
      <Typography variant="body2" noWrap>
        {formatOrderListDueDate(order)}
      </Typography>
      <Typography
        variant="caption"
        noWrap
        sx={{
          color: timing?.color ?? 'text.secondary',
          visibility: timing ? 'visible' : 'hidden',
        }}
      >
        {timing?.text ?? '\u00a0'}
      </Typography>
    </OrderListCell>
  );
};

export default OrderDueDateCell;
